import React, { useCallback, useEffect, useState, useMemo } from 'react';
import { Folders } from './Folders';
import { Files } from './Files';
import { useDispatch } from 'react-redux';
import { getFolder as onGetFolder } from '../../slices/thunks';
import BreadCrumb from './BreadCrumb';

function getIdAndName(folder) {
    const result = [];
    while (folder) {
        if (typeof folder.name !== 'undefined') {
            result.push({
                _id: folder._id,
                name: folder.name,
            });
        }
        folder = folder.parent_folder;
    }

    if (result.length > 0) {
        result.push({ _id: '/', name: 'Unidad Compartida' });
    }
    return result;
}

export const ContentSection = props => {
	const {
		current_folder,
		setCurrent_Folder,
		establishmentId
	} = props;
	const [route, setRoute] = useState([]);
	const [routeTree, setRouteTree] = useState([]);
	const [isLoading, setIsLoading] = useState(false);
	const dispatch = useDispatch();

	const [folderInfo, setFolderInfo] = useState([]);

	useEffect(() => {
		const info = getIdAndName(routeTree);
		setFolderInfo(info);
		setIsLoading(false); // Finaliza la carga cuando se establece folderInfo
	}, [routeTree]);

	const getRoute = useCallback(
		folder => {
			let route = [];
			const getRoute = folder => {
				route.push({
					title: folder?.name,
					function: () => setCurrent_Folder(folder),
				});
				if (folder.parent_folder) {
					getRoute(folder.parent_folder);
				}
			};
			getRoute(folder);
			return route;
		},
		[setCurrent_Folder]
	);

	useEffect(() => {
		setIsLoading(true); // Inicia la carga cuando comienza a obtener la carpeta
		if (current_folder._id !== '/') {
			dispatch(onGetFolder(current_folder._id)).then(({ payload }) => {
				setRouteTree(payload);
				let route = getRoute(payload);
				route.push({
					title: 'Unidad Compartida',
					function: () => setCurrent_Folder({ _id: '/', name: 'Unidad Compartida' }),
				});
				setRoute(route.reverse());
			});
		} else {
			setRouteTree([]);
			setRoute([
				{
					title: 'Unidad Compartida',
					function: () => setCurrent_Folder({ _id: '/', name: 'Unidad Compartida' }),
				},
			]);
			setIsLoading(false); // Finaliza la carga si la carpeta actual es la raíz
		}
	}, [current_folder]);

	const reversedFolderInfo = useMemo(() => folderInfo.reverse(), [folderInfo]);

	return (
		<div className='file-manager-content w-100 p-3 py-0'>
			<div className='mx-n3 pt-4 px-4 file-manager-content-scroll'>
				<BreadCrumb title={current_folder.name} links={reversedFolderInfo} setCurrent_Folder={setCurrent_Folder} isLoading={isLoading} />
				<Folders
					current_folder={current_folder}
					setCurrent_Folder={setCurrent_Folder}
					establishmentId={establishmentId}
				/>
			</div>
		</div>
	);
};
